/**
 * This function centralize the reduced animation preference to disable animations that are triggered via js.
 */
export function canAnimate(animateFn: Function) {
    return function (...args: any) {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');
        if (mediaQuery.matches) {
            animateFn(...args);
        }
    };
}
